import type { RouteRecordRaw } from 'vue-router';

export const payRoutes: Array<RouteRecordRaw> = [
  {
    path: '/payment',
    name: 'payment',
    redirect: '/payment/list',
    component: () => import('pages/micros/payment/McPayment.vue'),
    meta: {
      title: 'Payments',
    },
    children: [
      {
        path: 'process/new',
        name: 'paymentProcessingNew',
        component: () => import('pages/micros/payment/PaymentProcessingNew.vue'),
        meta: {
          title: 'New Payment Processing [Testing]',
          requiresAuth: true,
        },
      },
      {
        path: 'process',
        name: 'paymentProcessing',
        component: () => import('pages/micros/payment/PaymentProcessing.vue'),
        meta: {
          title: 'Payment Processing [Testing]',
          requiresAuth: true,
        },
      },
      {
        path: 'checkout',
        name: 'paymentCheckout',
        component: () => import('pages/micros/payment/process/PaymentCheckout.vue'),
        meta: {
          title: 'Payment Checkout',
          requiresAuth: true,
        },
      },
      {
        path: 'setup/intent',
        name: 'setupPaymentIntent',
        component: () => import('pages/micros/payment/process/SetupIntent.vue'),
        meta: {
          title: 'Setup Payment Intent',
          requiresAuth: true,
        },
      },
      {
        path: 'intent',
        name: 'paymentIntent',
        component: () => import('pages/micros/payment/process/PaymentIntent.vue'),
        meta: {
          title: 'Payment Intent',
          requiresAuth: true,
        },
      },

      {
        path: 'a/checkout/:sessionId?/:orderTitle?/:orderId?/:orderAmount?/:redirectPage?/:redirectPath?/:successPage?/:previousPage?/:currency?',
        name: 'paymentCheckout1',
        component: () => import('pages/micros/payment/process/PaymentCheckout.vue'),
        meta: {
          title: 'Payment Checkout',
          requiresAuth: true,
        },
      },
      {
        path: 'a/setup/intent/:setup_intent?/:setup_intent_client_secret?/:sessionId?/:orderTitle?/:orderId?/:orderAmount?/:redirectPage?/:redirectPath?/:successPage?/:previousPage?/:currency?',
        name: 'setupPaymentIntent1',
        component: () => import('pages/micros/payment/process/SetupIntent.vue'),
        meta: {
          title: 'Setup Payment Intent',
          requiresAuth: true,
        },
      },
      {
        path: 'a/intent/:payment_intent_client_secret?/:sessionId?/:orderTitle?/:orderId?/:orderAmount?/:redirectPage?/:redirectPath?/:successPage?/:previousPage?/:currency?',
        name: 'paymentIntent1',
        component: () => import('pages/micros/payment/process/PaymentIntent.vue'),
        meta: {
          title: 'Payment Intent',
          requiresAuth: true,
        },
      },
      {
        path: 'list',
        name: 'paymentList',
        component: () => import('pages/micros/payment/PaymentList.vue'),
        meta: {
          title: 'Payments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail',
        name: 'paymentDetail',
        component: () => import('pages/micros/payment/PaymentDetail.vue'),
        meta: {
          title: 'Payment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'view',
        name: 'paymentView',
        component: () => import('pages/micros/payment/PaymentView.vue'),
        meta: {
          title: 'Payment View',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'paymentNew',
        component: () => import('pages/micros/payment/PaymentNew.vue'),
        meta: {
          title: 'New Payment',
          requiresAuth: true,
        },
      },
      {
        path: '/provider',
        name: 'paymentProvider',
        redirect: '/provider/list',
        component: () => import('pages/micros/payment/provider/PaymentProvider.vue'),
        meta: {
          title: 'Payment Providers',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'paymentProviderList',
            component: () => import('pages/micros/payment/provider/PaymentProviderList.vue'),
            meta: {
              title: 'Payment Providers List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'paymentProviderDetail',
            component: () => import('pages/micros/payment/provider/PaymentProviderDetail.vue'),
            meta: {
              title: 'Payment Provider Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'paymentProviderNew',
            component: () => import('pages/micros/payment/provider/PaymentProviderNew.vue'),
            meta: {
              title: 'New Payment Provider',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: '/card',
        name: 'paymentCard',
        redirect: '/card/list',
        component: () => import('pages/micros/payment/card/PaymentCard.vue'),
        meta: {
          title: 'Payment Cards',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'paymentCardList',
            component: () => import('pages/micros/payment/card/PaymentCardList.vue'),
            meta: {
              title: 'Payment Cards List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'paymentCardDetail',
            component: () => import('pages/micros/payment/card/PaymentCardDetail.vue'),
            meta: {
              title: 'Payment Card Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'paymentCardNew',
            component: () => import('pages/micros/payment/card/PaymentCardNew.vue'),
            meta: {
              title: 'New Payment Card',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: '/customer',
        name: 'paymentCustomer',
        redirect: '/customer/list',
        component: () => import('pages/micros/payment/customer/PaymentCustomer.vue'),
        meta: {
          title: 'Payment Customers',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'paymentCustomerList',
            component: () => import('pages/micros/payment/customer/PaymentCustomerList.vue'),
            meta: {
              title: 'Payment Customers List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'paymentCustomerDetail',
            component: () => import('pages/micros/payment/customer/PaymentCustomerDetail.vue'),
            meta: {
              title: 'Payment Customer Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'paymentCustomerNew',
            component: () => import('pages/micros/payment/customer/PaymentCustomerNew.vue'),
            meta: {
              title: 'New Payment Customer',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: '/method',
        name: 'paymentMethod',
        redirect: '/method/list',
        component: () => import('pages/micros/payment/method/PaymentMethod.vue'),
        meta: {
          title: 'Payment Methods',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'paymentMethodList',
            component: () => import('pages/micros/payment/method/PaymentMethodList.vue'),
            meta: {
              title: 'Payment Methods List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'paymentMethodDetail',
            component: () => import('pages/micros/payment/method/PaymentMethodDetail.vue'),
            meta: {
              title: 'Payment Method Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'paymentMethodNew',
            component: () => import('pages/micros/payment/method/PaymentMethodNew.vue'),
            meta: {
              title: 'New Payment Method',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: '/refund',
        name: 'paymentRefund',
        redirect: '/refund/list',
        component: () => import('pages/micros/payment/refund/PaymentRefund.vue'),
        meta: {
          title: 'Payment Refunds',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'paymentRefundList',
            component: () => import('pages/micros/payment/refund/PaymentRefundList.vue'),
            meta: {
              title: 'Payment Refunds List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail',
            name: 'paymentRefundDetail',
            component: () => import('pages/micros/payment/refund/PaymentRefundDetail.vue'),
            meta: {
              title: 'Payment Refund Details',
              requiresAuth: true,
            },
          },
          {
            path: 'a/detail/:itemId?/:reason?/:status?/:refundAppFee?/:paymentIntent?/:orderAmount?/:refundableAmount?/:orderId?/:paymentCategory?/:paymentStatus?',
            name: 'paymentRefundDetail',
            component: () => import('pages/micros/payment/refund/PaymentRefundDetail.vue'),
            meta: {
              title: 'Payment Refund Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'paymentRefundNew',
            component: () => import('pages/micros/payment/refund/PaymentRefundNew.vue'),
            meta: {
              title: 'New Payment Refund',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: '/sub',
        name: 'paymentSub',
        redirect: '/sub/list',
        component: () => import('pages/micros/payment/sub/PaymentSub.vue'),
        meta: {
          title: 'Payment Subscriptions',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'paymentSubList',
            component: () => import('pages/micros/payment/sub/PaymentSubList.vue'),
            meta: {
              title: 'Payment Subscriptions List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'paymentSubDetail',
            component: () => import('pages/micros/payment/sub/PaymentSubDetail.vue'),
            meta: {
              title: 'Payment Subscription Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'paymentSubNew',
            component: () => import('pages/micros/payment/sub/PaymentSubNew.vue'),
            meta: {
              title: 'New Payment Subscription',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
